
import Vue from "vue";
import Component from "vue-class-component";
import { State } from "vuex-class";
import { Prop } from "vue-property-decorator";

@Component
export default class AppNavbar4 extends Vue {
  @State("school", { namespace: "school" })
  private school!: any;
  @State("template", { namespace: "school" })
  private template!: any;

  @Prop({ default: false })
  private mobileMenu!: boolean;
  @Prop({ default: null })
  private onNavigateJobFair!: any;
  @Prop({ default: null })
  private goHome!: any;
  @Prop({ default: null })
  private onClick!: any;
  @Prop({ default: null })
  private onMoreNews!: any;
}
